import { createFileRoute } from '@tanstack/react-router'
import { useDocumentTitle } from 'usehooks-ts'
import { APP_NAME } from '@/lib/env'
import SopShareInvitePage from '@/pages/sops/Invite'

export const Route = createFileRoute('/(auth)/sop-share-invite')({
  component: RouteComponent,
  validateSearch: (search) => {
    return {
      invitationId: search.invitationId as string | undefined,
    }
  },
})

function RouteComponent() {
  const { invitationId } = Route.useSearch()
  useDocumentTitle(`Invite - ${APP_NAME}`)

  return <SopShareInvitePage invitationId={invitationId} />
}
